import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { requestType } from '../models/vs-models/api-service-options.model';
import { ApiEndpoints } from '../models/vs-models/all-urls.model';
import { ApiHandlingService } from '../services/vs-services/api-handler.service';
import { Injectable } from '@angular/core';
import { LoginSessionInterface } from '../models/vs-interfaces/loginSessionInterface';
import { AccessSessionStorage } from '../services/vs-services/session-storage.service';
import { UserDetails } from '../models/vs-models/user-details.model';

@Injectable({ providedIn: 'root' })
export class groupGuardGuard{
  loggedInSession: LoginSessionInterface;
  userDetails: UserDetails = JSON.parse(this.userSession.getLoginSessionData('userDetails'));
  email=this.userDetails.email;
    constructor(private apiHandle: ApiHandlingService,
        private router: Router,
        private userSession: AccessSessionStorage
) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isValid:boolean = false;
    this.userDetails = JSON.parse(this.userSession.getLoginSessionData('userDetails'));
    this.email=this.userDetails.email;
    let chckDto = {
      "email": this.email,
      "link": route.data.url
    }
    this.apiHandle.getReq(
      requestType.METHOD_POST, ApiEndpoints.CHECK_UI_FOR_EMAIL+"?email="+this.email,chckDto).subscribe(
          (responseFD: boolean) => {
        if(responseFD==true){
          return true;
        }else{
          this.router.navigate(['/account/auth/login'], { queryParams: { returnUrl: state.url } });
          return false;
        }
      })
  }
  
};

